module.exports = "/assets/images/close_e028fa.svg";